/**
 * @module views\sys\db\templates\dynamicProperty\numberProperty
 */
import Vue from "vue";
import Component from "vue-class-component";
import BaseEditor from "../../base";

@Component
export default class NumberProperty extends BaseEditor {}
